import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MapPoint, MapStop, MapTrackingPoints } from '../../common/models';
import { TransportMode } from '../../common/constants/transport-mode';
import { IconNames } from '../../common/constants/icon-names';

@Component({
    selector: 'container-expansion-map',
    templateUrl: './expansion-map.component.html',
    styleUrls: ['./expansion-map.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ExpansionMapComponent {
  @Input() transportMode: TransportMode;
  @Input() mapData: MapTrackingPoints<MapStop, MapPoint>;
  @Input() expanded = false;
  @Output() mapLoad = new EventEmitter<void>();

  iconNames = IconNames;
}
